import React, { useMemo } from "react";

import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import OpeningHours from "shared/components/OpeningHours";
import Popover from "shared/components/Popover";
import Pin from "shared/components/SVG/Pin";
import WarningLocation from "shared/components/SVG/WarningLocation";
import { NAME_SPACES } from "shared/locals/constants";
import { COLORS } from "shared/style/colors";
import { PATHS } from "utils/constants";
import { formatOpeninHours } from "utils/helpers/hours";
import { useInfo } from "utils/hooks/info";

const Component = () => {
  const {
    info,
    info: { phone },
  } = useInfo();
  const history = useHistory();
  const { id: folderNum } = useParams();
  const { t } = useTranslation(NAME_SPACES.HOME, {
    keyPrefix: "PLANING_WARNING",
  });
  const openingHours = useMemo(
    () => formatOpeninHours(info.openHours),
    [info.openHours],
  );

  const onAddress = () => {
    history.push(PATHS.FILE.ADDRESS.replace(":id", folderNum));
  };
  return (
    <div className={"rendezvous-warning"}>
      <WarningLocation />
      <p className={"title"}>{t("TITLE")}</p>
      <p className={"description"}>{t("DESCRIPTION")}</p>
      <p className={"address"} onClick={onAddress}>
        <Pin color={COLORS.CHRYSOPRASE_MEDIUM} />
        {` ${t("ADDRESS")}`}
      </p>
      <p className={"description"}>{t("PHONE_CONTACT")}</p>
      <p className={"contact"}>{t("NUMBER", { phone })}</p>
      <Popover content={<OpeningHours data={openingHours} />}>
        <p className={"info"}>{t("OPENING_HOURS")}</p>
      </Popover>
    </div>
  );
};

Component.propTypes = {
  data: PropTypes.shape({
    date: PropTypes.string,
    intervals: PropTypes.shape({
      start: PropTypes.string,
      end: PropTypes.string,
    }),
  }),
};
export default Component;
